import axios from 'axios';
import { apiUri } from 'config';
import { authenticationState } from 'app/authentication/state';

export type GetAzureSignedLinkObjectResponse = {
  container: 'outlet';
  query: string;
  url: string;
};

// Timeout for getting signed URL - fail fast if offline
const SIGNED_URL_TIMEOUT_MS = 10000;

export const getAzureSignedObjectLink = () => {
  const { token } = authenticationState();

  return axios
    .post<GetAzureSignedLinkObjectResponse>(`${apiUri}/api/v1/azurestorage/upload/objects`, null, {
      headers: {
        authorization: `Bearer ${token}`,
      },
      timeout: SIGNED_URL_TIMEOUT_MS,
    })
    .then((response) => response.data);
};
